/** Auth user token key */
export const AUTH_USER_TOKEN_KEY = 'mhfc.TokenKey'
export const expirationTimeInMinutes = parseInt(
  process.env.REACT_APP_COOKIE_EXPIRATION_TIME_BY_MINUTES || '45',
  10,
)
